import { render, staticRenderFns } from "./personalSuperiority.vue?vue&type=template&id=192da082&scoped=true"
import script from "./personalSuperiority.vue?vue&type=script&lang=js"
export * from "./personalSuperiority.vue?vue&type=script&lang=js"
import style0 from "./personalSuperiority.vue?vue&type=style&index=0&id=192da082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192da082",
  null
  
)

export default component.exports